import { EvalEvents } from 'v2/utils/event-bus/eval-events'

export const EVENT_LABELS: Record<string, string> = {
  [EvalEvents.STARTED]: 'Simulation started',
  [EvalEvents.DATASET_GENERATION_STARTED]: 'Dataset generation started',
  [EvalEvents.DATASET_GENERATION_COMPLETED]: 'Dataset generation completed',
  [EvalEvents.DATASET_GENERATION_TEST_CASE]: 'Generated test case',
  [EvalEvents.RESULT]: 'Simulation result',
  [EvalEvents.COMPLETED]: 'Simulation completed',
  [EvalEvents.CANCELLED]: 'Simulation cancelled',
  [EvalEvents.NODE_EVALUATION_SKIPPED]: 'Node skipped',
  [EvalEvents.ERROR]: 'Simulation error',
  [EvalEvents.STREAM_ENDED]: 'Stream ended',
} as const

export const METRIC_EXPECTED_RESPONSE: Record<string, string> = {
  Hallucination:
    'The response should not contain any fabricated or made-up information. All details must be grounded in the provided context.',
  'Freeflow Response Accuracy':
    'The response should maintain natural conversational flow and address the user input contextually.',
  'Loop Detection':
    'The agent should not repeat the same question or message from earlier in the conversation.',
  'Semi Rigid Response Accuracy':
    'The response should follow the guidelines and maintain the expected tone and format.',
  'Knowledge Base Correctness':
    'The knowledge base should only be searched when the answer is not available in the conversation history or instructions.',
  'Tool Correctness': 'The correct tool should be called based on the context and user input.',
}

export const METRIC_LABELS: Record<string, string> = {
  'Freeflow Response Accuracy': 'Message Accuracy',
  'Semi Rigid Response Accuracy': 'Message Accuracy',
  'Rigid Response Accuracy': 'Message Accuracy',
}

/**
 * Get the label for a metric, or undefined if it should show the JSON response
 */
export const getMetricExpectedResponse = (metricName: string): string | undefined => {
  return METRIC_EXPECTED_RESPONSE[metricName.trim()]
}
export const getMetricLabel = (metricName: string): string | undefined => {
  return METRIC_LABELS[metricName.trim()]
}
